import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { SubmitHandler, useForm } from "react-hook-form";
import {
  Flex,
  FormControl,
  FormErrorMessage,
  Stack,
  Text,
  Grid,
  Box,
  Img,
  useMediaQuery,
  Link,
} from "@chakra-ui/react";

import { Title } from "../../components/title/Title";
import { themeChakra } from "../../styles/theme-chakra";

import { Input } from "../../components/input/Input";
import { Button } from "../../components/button/Button";
import { AuthLabel } from "../../components/label/Label";
import { useNavigate } from "react-router-dom";

type Form = {
  email: string;
};

export const RecoverPassword = () => {
  const navigate = useNavigate();

  const createFormSchema = yup.object({
    email: yup
      .string()
      .required("Por favor, insira seu email")
      .email("Email inválido"),
  });

  const { register, formState, handleSubmit } = useForm<Form>({
    mode: "onChange",
    resolver: yupResolver(createFormSchema),
  });

  const { errors } = formState;

  const [isLargerThan767] = useMediaQuery("(min-width: 767px)");

  const handleSend: SubmitHandler<Form> = async (values) => {
    setTimeout(() => {
      console.log(values);
    }, 2000);

    navigate(`/alterar/${values.email}`);
  };

  return (
    <Grid
      templateColumns={isLargerThan767 ? "1.1fr 1fr" : "1fr"}
      gap={0}
      minHeight="100vh"
    >
      {isLargerThan767 && (
        <Box position="relative">
          <Img
            src="/mulher.png"
            alt="Imagem"
            objectFit="cover"
            w="100%"
            h="100vh"
          />
        </Box>
      )}

      <Flex direction="column" justify="center" align="center">
        <Box
          position="relative"
          width={isLargerThan767 ? "70%" : "100%"}
          maxWidth={500}
          display="flex"
          flexDirection="column"
          alignItems="center"
          p={isLargerThan767 ? 8 : 2}
        >
          <Title>RECUPERAR</Title>
          <Text
            fontFamily={themeChakra.fonts.heading}
            textAlign="center"
            color={themeChakra.colors.blue[600]}
            width="100%"
          >
            Enviaremos um email com instruções de como redefinir sua senha
          </Text>

          <Flex
            width="100%"
            flexDirection="column"
            as="form"
            onSubmit={handleSubmit(handleSend)}
          >
            <FormControl isInvalid={!!errors.email}>
              <Stack>
                <AuthLabel htmlFor="email">Email</AuthLabel>
                <Input type="email" {...register("email")} />
                <FormErrorMessage
                  color={themeChakra.colors.red[200]}
                  marginTop="-16px"
                >
                  {errors.email?.message}
                </FormErrorMessage>
              </Stack>
            </FormControl>

            <Button>Enviar</Button>
          </Flex>

          <Link margin="16px 0" color={themeChakra.colors.red[200]}>
            Não lembro meu email
          </Link>
        </Box>
      </Flex>
    </Grid>
  );
};
